import React, { useEffect, useState, useRef } from 'react';
import TechGptWidget from './TechGptWidget';
import PropTypes from 'prop-types';

function TechGpt({ isOpen, toggle }) {
  return (
    <>
      {isOpen && <TechGptWidget closeToggle={toggle} />}
    </>
  );
}

TechGpt.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

export default TechGpt;
// eski kaydırılabilir TechGpt bileşeni
/* 
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Container from '@material-ui/core/Container';
import { ButtonBase, Card, CssBaseline } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import Box from '@material-ui/core/Box';
import TechGPTSVGIcon from '../../assets/images/chat-logo-techgpt.svg';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {},
  gptHideClose: {
    cursor: 'grab',
    zIndex: 1301,
    position: 'fixed',
    touchAction: 'none',
    userSelect: 'none',
    transition: 'none',
    '&:active': {
      cursor: 'grabbing'
    }
  },
  dragIndicator: {
    position: 'absolute',
    top: -8,
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    padding: '4px 8px',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    borderRadius: 8,
    pointerEvents: 'none',
    zIndex: 1
  },
  dragDot: {
    width: 4,
    height: 4,
    backgroundColor: '#fff',
    borderRadius: '50%'
  },
  dragLine: {
    width: 20,
    height: 2,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    borderRadius: 1,
    margin: '1px 0'
  }
}));

function TechGpt(props, className) {

  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState(() => {
    const savedPosition = localStorage.getItem('techgpt-position');
    if (savedPosition) {
      const pos = JSON.parse(savedPosition);
      const maxBottom = window.innerHeight - 120;
      const maxRight = window.innerWidth - 120;
      return {
        bottom: Math.max(10, Math.min(maxBottom, pos.bottom)),
        right: Math.max(10, Math.min(maxRight, pos.right))
      };
    }
    return { bottom: 80, right: 10 };
  });
  const [isDragging, setIsDragging] = useState(false);
  const dragRef = useRef(null);
  const startPos = useRef({ x: 0, y: 0 });
  const startTouch = useRef({ x: 0, y: 0 });

  useEffect(() => {
    localStorage.setItem('techgpt-position', JSON.stringify(position));
  }, [position]);

  useEffect(() => {
    const handleResize = () => {
      setPosition(prev => {
        const maxBottom = window.innerHeight - 120;
        const maxRight = window.innerWidth - 120;
        return {
          bottom: Math.max(10, Math.min(maxBottom, prev.bottom)),
          right: Math.max(10, Math.min(maxRight, prev.right))
        };
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  function toggle() {
    if (!isDragging) {
      setIsOpen((isOpen) => !isOpen);
    }
  }

  const handleTouchStart = (e) => {
    const touch = e.touches[0];
    startTouch.current = { x: touch.clientX, y: touch.clientY };
    startPos.current = { ...position };
    setIsDragging(false);
  };

  const handleTouchMove = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    const deltaX = startTouch.current.x - touch.clientX;
    const deltaY = startTouch.current.y - touch.clientY;

    if (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5) {
      setIsDragging(true);
    }

    const newBottom = startPos.current.bottom + deltaY;
    const newRight = startPos.current.right + deltaX;

    const maxBottom = window.innerHeight - 120;
    const maxRight = window.innerWidth - 120;

    setPosition({
      bottom: Math.max(10, Math.min(maxBottom, newBottom)),
      right: Math.max(10, Math.min(maxRight, newRight))
    });
  };

  const handleTouchEnd = () => {
    setTimeout(() => setIsDragging(false), 200);
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    startTouch.current = { x: e.clientX, y: e.clientY };
    startPos.current = { ...position };
    setIsDragging(false);

    const handleMouseMove = (moveEvent) => {
      const deltaX = startTouch.current.x - moveEvent.clientX;
      const deltaY = startTouch.current.y - moveEvent.clientY;

      if (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5) {
        setIsDragging(true);
      }

      const newBottom = startPos.current.bottom + deltaY;
      const newRight = startPos.current.right + deltaX;

      const maxBottom = window.innerHeight - 120;
      const maxRight = window.innerWidth - 120;

      setPosition({
        bottom: Math.max(10, Math.min(maxBottom, newBottom)),
        right: Math.max(10, Math.min(maxRight, newRight))
      });
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      setTimeout(() => setIsDragging(false), 200);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const handleClick = (e) => {
    e.stopPropagation();
    if (!isDragging) {
      toggle();
    }
  };

  return (
    <>
      {
        isOpen ? (
          <TechGptWidget closeToggle={toggle} />
        ) : (
          <div
            ref={dragRef}
            className={classes.gptHideClose}
            style={{
              bottom: `${position.bottom}px`,
              right: `${position.right}px`
            }}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            onMouseDown={handleMouseDown}
            onClick={handleClick}
          >
            <div className={classes.dragIndicator}>
              <div className={classes.dragLine}></div>
              <div className={classes.dragLine}></div>
              <div className={classes.dragLine}></div>
            </div>

            <img
              height={100}
              width={100}
              src={TechGPTSVGIcon}
              alt="TechGPT"
              style={{ pointerEvents: 'none' }}
            />
          </div>
        )
      }
    </>
  );
}

export default TechGpt;
 */